/** @jsx jsx */

import { css, jsx } from '@emotion/react';
const formFooterWrapperStyles = css({
  display: 'flex',
  marginTop: "var(--ds-space-300, 24px)",
  justifyContent: 'flex-end'
});
const justifyContentStyles = css({
  justifyContent: 'flex-start'
});

/**
 * __Form footer__
 *
 * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
export default function FormFooter({
  align = 'end',
  children
}) {
  return jsx("footer", {
    css: [formFooterWrapperStyles, align === 'start' && justifyContentStyles]
  }, children);
}